import { defineComponent as K, ref as m, computed as X, onMounted as Y, onBeforeUnmount as Z, watch as ee, createElementBlock as te, openBlock as p, normalizeClass as B, unref as r, createBlock as T, createCommentVNode as P, createElementVNode as D, isRef as oe, createVNode as re } from "vue";
import { isDefined as se } from "@scalar/oas-utils/helpers";
import { safeJSON as ae } from "@scalar/object-utils/parse";
import { useToasts as ne } from "@scalar/use-toasts";
import { RouterView as le } from "vue-router";
import { useAnalytics as ue } from "../../analytics.js";
import ce from "../../components/Sidebar/SidebarToggle.vue.js";
import { useClientConfig as ie } from "../../hooks/useClientConfig.js";
import { useSidebar as me } from "../../hooks/useSidebar.js";
import { validateParameters as fe } from "../../libs/validate-parameters.js";
import { useActiveEntities as de } from "../../store/active-entities.js";
import { useOpenApiWatcher as pe } from "./hooks/useOpenApiWatcher.js";
import ve from "./RequestSidebar.vue.js";
import { usePluginManager as Re } from "../../plugins/hooks/usePluginManager.js";
import { createRequestOperation as Se } from "../../libs/send-request/create-request-operation.js";
import { ERRORS as qe } from "../../libs/errors.js";
import { useWorkspace as ye } from "../../store/store.js";
import { useLayout as xe } from "../../hooks/useLayout.js";
const be = { class: "flex h-full" }, he = { class: "flex h-full flex-1 flex-col" }, We = /* @__PURE__ */ K({
  __name: "RequestRoot",
  emits: ["newTab"],
  setup(ge) {
    const M = ye(), { toast: v } = ne(), { layout: R } = xe(), z = ie(), { isSidebarOpen: a } = me(), f = ue(), {
      activeCollection: l,
      activeExample: u,
      activeEnvironment: S,
      activeRequest: c,
      activeWorkspace: q,
      activeServer: I
    } = de(), { cookies: J, requestHistory: W, showSidebar: y, securitySchemes: j, events: s } = M, L = Re(), $ = m(), x = m(), d = m(/* @__PURE__ */ new Set()), b = m(null), h = X(
      () => {
        var e, t, o;
        return ((e = l.value) != null && e.useCollectionSecurity ? (t = l.value) == null ? void 0 : t.selectedSecuritySchemeUids : (o = c.value) == null ? void 0 : o.selectedSecuritySchemeUids) ?? [];
      }
    ), g = async () => {
      var _, w, O, V, i, A;
      if (!c.value || !u.value || !l.value)
        return;
      d.value = fe(u.value);
      const e = typeof S.value == "object" ? S.value.value : "{}", t = ae.parse(e);
      t.error && console.error("INVALID ENVIRONMENT!");
      const o = t.error || typeof t.data != "object" ? {} : t.data ?? {}, n = ((_ = q.value) == null ? void 0 : _.cookies.map((G) => J[G]).filter(se)) ?? [], F = ((O = (w = l.value) == null ? void 0 : w.info) == null ? void 0 : O.title) === "Drafts" ? void 0 : I.value, [E, C] = Se({
        request: c.value,
        example: u.value,
        selectedSecuritySchemeUids: h.value,
        proxyUrl: ((V = q.value) == null ? void 0 : V.proxyUrl) ?? "",
        environment: o,
        globalCookies: n,
        status: s.requestStatus,
        securitySchemes: j,
        server: F,
        pluginManager: L
      });
      if ((A = (i = z.value) == null ? void 0 : i.onRequestSent) == null || A.call(i, c.value.path ?? ""), E) {
        v(E.message, "error");
        return;
      }
      x.value = C.controller;
      const [N, U] = await C.sendRequest();
      b.value = U, N ? v(N.message, "error") : W.push(Q(U));
    }, H = async () => {
      var e;
      return (e = x.value) == null ? void 0 : e.abort(qe.REQUEST_ABORTED);
    };
    function k() {
      f == null || f.capture("client-send-request");
    }
    Y(() => {
      s.executeRequest.on(g), s.executeRequest.on(k), s.cancelRequest.on(H);
    }), pe(), Z(() => {
      s.executeRequest.off(g), s.executeRequest.off(k);
    }), ee(
      () => {
        var e;
        return (e = u.value) == null ? void 0 : e.parameters;
      },
      () => {
        d.value.clear();
      },
      { deep: !0 }
    );
    const Q = (e) => {
      var t;
      try {
        return structuredClone(e);
      } catch {
        const n = { ...e };
        return (t = e.response) != null && t.data && (e.response.data instanceof Blob || e.response.data instanceof ArrayBuffer ? n.response.data = e.response.data : n.response.data = JSON.parse(JSON.stringify(e.response.data))), n;
      }
    };
    return (e, t) => (p(), te("div", {
      ref_key: "element",
      ref: $,
      class: B(["bg-b-1 relative z-0 flex h-full flex-1 flex-col overflow-hidden pt-0", {
        "!mr-0 !mb-0 !border-0": r(R) === "modal"
      }])
    }, [
      r(y) ? (p(), T(ce, {
        key: 0,
        modelValue: r(a),
        "onUpdate:modelValue": t[0] || (t[0] = (o) => oe(a) ? a.value = o : null),
        class: B(["absolute top-2 left-3 z-50", [
          { hidden: r(a) },
          { "xl:!flex": !r(a) },
          { "!flex": r(R) === "modal" }
        ]])
      }, null, 8, ["modelValue", "class"])) : P("", !0),
      D("div", be, [
        r(y) ? (p(), T(ve, {
          key: 0,
          onNewTab: t[1] || (t[1] = (o) => e.$emit("newTab", o))
        })) : P("", !0),
        D("div", he, [
          re(r(le), {
            invalidParams: d.value,
            requestResult: b.value,
            selectedSecuritySchemeUids: h.value
          }, null, 8, ["invalidParams", "requestResult", "selectedSecuritySchemeUids"])
        ])
      ])
    ], 2));
  }
});
export {
  We as default
};
